import { produce } from 'immer';
import { createReducer } from 'typesafe-actions';
import type { ActionType } from 'typesafe-actions';

import * as actions from './actions';
import type { DemandReportingState } from './types';

const { getPersonalLoanSummaryByDemandSubAccountUuidAction } = actions;

export const initialDemandReportingState: DemandReportingState = {
  personaLoanSummaryByDemandSubAccountUuid: {},
};

export const demandReportingReducer = createReducer<
  DemandReportingState,
  ActionType<typeof actions>
>(initialDemandReportingState).handleAction(
  getPersonalLoanSummaryByDemandSubAccountUuidAction.success,
  (state, { payload }) =>
    produce(state, (draftState) => {
      draftState.personaLoanSummaryByDemandSubAccountUuid = {
        ...state.personaLoanSummaryByDemandSubAccountUuid,
        [payload.demandSubAccountUuid]: payload.loanSummary,
      };
    })
);
